import { ApolloClient, ApolloLink } from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { split } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import { getToken } from 'shared/Common';

// 참고 : https://www.apollographql.com/docs/link/links/http/

console.log(`https://${process.env.REACT_APP_END_POINT}`);

const httpLink = new createHttpLink({
  uri: `https://${process.env.REACT_APP_END_POINT}`,
});

const authLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: getToken(),
    },
  }));

  // operation.variables.shopId = operation.variables.shopId ? operation.variables.shopId : parseInt(getQrKey().split('/')[0]);
  // operation.variables.qrKey = getQrKey();
  // operation.variables.uuid = getUserId();

  return forward(operation);
});

const httpAuthLink = authLink.concat(httpLink);

// 웹소켓으로 gql을 사용하지 않는다면 wsLint 관련부분을 삭제바랍니다.
// Create a WebSocket link:
const wsLink = new WebSocketLink({
  uri: `wss://${process.env.REACT_APP_END_POINT}`,
  options: {
    reconnect: true,
    // timeout: 20 * 1000, // 30분
    connectionParams: {
      authorization: getToken(),
    },
  },
});

wsLink.subscriptionClient.on('connecting', () => {
  console.log('connecting');
});

wsLink.subscriptionClient.on('connected', () => {
  console.log('connected');
});

wsLink.subscriptionClient.on('reconnecting', () => {
  console.log('reconnecting');
});

wsLink.subscriptionClient.on('reconnected', () => {
  console.log('reconnected');
});

wsLink.subscriptionClient.on('disconnected', () => {
  console.log('disconnected');
});

// wsLink.subscriptionClient.maxConnectTimeGenerator.duration = () =>
//   wsLink.subscriptionClient.maxConnectTimeGenerator.max;

const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  httpAuthLink,
);

const client = new ApolloClient({
  link: link,
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

export default client;
